import { useState } from 'react';
import { Box, MenuItem, Stack, IconButton, Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../../redux/account.slice';

const LANGS = [
  { value: 'uz', label: 'Uzbek', icon: '/assets/icons/ic_flag_uz.png' },
  { value: 'ru', label: 'Russian', icon: '/assets/icons/ic_flag_ru.png' },
];

export default function LanguagePopover() {
  const [open, setOpen] = useState(null);
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.account);

  const handleOpen = (event) => setOpen(event.currentTarget);
  const handleClose = () => setOpen(null);

  const handleLanguageChange = (value) => {
    dispatch(setLanguage(value));
    handleClose();
  };

  const currentLang = LANGS.find((lang) => lang.value === language);

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={(theme) => ({
          width: 38,
          height: 38,
          padding: 0.75,
          border: `1px solid ${open ? theme.palette.grey[400] : 'transparent'}`,
          '&:hover': { backgroundColor: theme.palette.grey[100] },
        })}
      >
        <Box
          component="img"
          src={currentLang?.icon}
          alt={currentLang?.label}
          sx={{ width: 22, height: 22, objectFit: 'cover', borderRadius: '50%' }}
        />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { mt: 1, width: 180, p: 0.5 } }}
      >
        <Stack>
          {LANGS.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === language}
              onClick={() => handleLanguageChange(option.value)}
            >
              <Box
                component="img"
                alt={option.label}
                src={option.icon}
                sx={{ width: 22, height: 22, mr: 1.5, borderRadius: '50%', objectFit: 'cover' }}
              />
              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </Popover>
    </>
  );
}
